<div class="content-header">
    <h2>Consulta folio de envío de demanda</h2>
</div>

<div class="form-section">
    <h3 class="h3-title">Indique el número de folio de la solicitud a consultar</h3>

    <form [formGroup]="formConsulta" novalidate (ngSubmit)="buscar()">
        <div class="row">
            <div class="col-3">
                <div class="form-group">
                    <label for="tipo-filtro">Número de folio:</label>
                    <input type="text" class="form-control"
                        [class.is-invalid]="formConsulta.get('folio')?.invalid && formConsulta.get('folio')?.touched"
                        id="promovente" formControlName="folio">

                    @if (formConsulta.get('folio')?.errors && formConsulta.get('folio')?.touched) {
                    @if (formConsulta.get('folio')?.hasError('required')) {
                    <div class="invalid-feedback">
                        <span>El folio es requerido</span>
                    </div>
                    }
                    @if (formConsulta.get('folio')?.hasError('pattern')) {
                    <div class="invalid-feedback">
                        <span>Solo se permiten números</span>
                    </div>
                    }
                    }
                </div>
            </div>
        </div>

        <button type="submit" [disabled]="loading" class="btn btn-envio mt-4">
            <i class="fas fa-search icon"></i> Buscar folio
        </button>
    </form>

    <oaj-alert-itx></oaj-alert-itx>

    <div class="center">
        <oaj-loader-itx [loading]="loading" [sMensaje]="sMensajeLoad" #loaderSpinner></oaj-loader-itx>
    </div>
</div>